import { gql } from "@apollo/client";

export const CREATE_PROSPECTION = gql`
  mutation CreateProspectionMutation($input: CreateProspectionInput!) {
    createProspection(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_PROSPECTION = gql`
  mutation UpdateProspectionMutation($id: Int!, $input: UpdateProspectionInput!) {
    updateProspection(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_PROSPECTION = gql`
  mutation RemoveProspectionMutation($id: Int!) {
    removeProspection(id: $id) {
      ok
      error
    }
  }
`;

export const PROSPECTION = gql`
  query ProspectionQuery($id: Int!) {
    prospection(id: $id) {
      ok
      error
      result {
        id
        type
        automatique
        phone
        email
        message
        customerId
        customer {
          id
          name
          site
          phone
        }
        sentBy {
          id
          firstname
          lastname
        }
      }
    }
  }
`;

export const PROSPECTIONS = gql`
  query ProspectionsQuery($where: ProspectionsFiltersInput!) {
    prospections(where: $where) {
      ok
      error
      total
      results {
        id
        type
        automatique
        phone
        email
        message
        createdAt
        customerId
        customer {
          id
          name
          site
        }
        sentBy {
          id
          firstname
          lastname
        }
      }
    }
  }
`;
